module.exports = __webpack_public_path__ + "static/Inventory-Warehouse-Automation-6dff74b430d7597389f9534a1a6c05c7.jpg";